import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { InputNumber, Slider, Button, Row, Col } from 'antd';
import { formatMoney, unFormat } from 'shared/utils/StringUtil';

class FormAmountRange extends Component {
  constructor(props) {
    super(props);
    this.state = {
      amountRange: props.range,
    };
  }

  _onCancel = () => {
    this.props.cancelFunction(this.props.type, this.props.flagPrefix);
  };

  _handleSubmit = e => {
    e.preventDefault();
    this.props.onSubmit(
      this.props.type,
      { input: this.state.amountRange },
      this.props.flagPrefix,
    );
  };

  _onChangeNumInput = isMax => value => {
    const amountRange = prevState =>
      isMax
        ? [prevState.amountRange[0], value]
        : [value, prevState.amountRange[1]];

    this.setState(prev => ({
      amountRange: amountRange(prev),
    }));
  };

  _renderNumInput = isMax => {
    const { range } = this.props;
    const defaultInputProps = {
      min: isMax ? this.state.amountRange[0] : range[0],
      max: isMax ? range[1] : this.state.amountRange[1],
      step: 10000,
      value: isMax ? this.state.amountRange[1] : this.state.amountRange[0],
      style: {
        width: '124px',
        display: 'block',
      },
      onChange: this._onChangeNumInput(isMax),
      formatter: formatMoney,
      parser: unFormat,
    };
    return <InputNumber {...defaultInputProps} />;
  };

  _onChange = amountRange => {
    this.setState({ amountRange });
  };

  _renderRangeInput = () => (
    <div>
      <Row>
        <Col span={12} style={{ paddingRight: 5 }}>
          {this._renderNumInput(false)}
        </Col>

        <Col span={12} style={{ paddingLeft: 5 }}>
          {this._renderNumInput(true)}
        </Col>
      </Row>
      <Row>
        <Slider
          range
          min={this.props.range[0]}
          max={this.props.range[1]}
          step={10000}
          value={this.state.amountRange}
          onChange={this._onChange}
        />
      </Row>
    </div>
  );

  _renderForm = () => (
    <Row>
      <Col className="tright">
        {this._renderRangeInput()}
        <div className="row-submit">
          <Button className="btn cancel-btn" onClick={this._onCancel}>
            Cancel
          </Button>
          <Button type="primary" className="btn" onClick={this._handleSubmit}>
            Submit
          </Button>
        </div>
      </Col>
    </Row>
  );

  render() {
    return <div>{this._renderForm()}</div>;
  }
}

FormAmountRange.propTypes = {
  onSubmit: PropTypes.func.isRequired,
  cancelFunction: PropTypes.func.isRequired,
  type: PropTypes.string.isRequired,
  flagPrefix: PropTypes.string,
  range: PropTypes.array,
};

export default FormAmountRange;
